import React, { useState, useEffect, useContext } from "react";

const DetectOfflineContext = React.createContext(true);

const PING_RESOURCE = "https://redfoxcafe.ir/ping.txt";
const TIMEOUT_TIME_MS = 3000;
const onlinePollingInterval = 10000;

const timeout = (time, promise) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error("Request time out"));
    }, time);
    promise.then(resolve, reject);
  });
};

const checkOnlineStatus = async () => {
  const controller = new AbortController();
  const { signal } = controller;

  if (!navigator.onLine) return navigator.onLine;

  try {
    await timeout(
      TIMEOUT_TIME_MS,
      fetch(PING_RESOURCE, {
        method: "GET",
        signal,
      })
    );
    return true;
  } catch (error) {
    console.error(error);

    controller.abort();
  }
  return false;
};

export function useDetectOffline() {
  return useContext(DetectOfflineContext);
}

export function DetectOfflineProvider({ children }) {
  const [onlineStatus, setOnlineStatus] = useState(true);

  const checkStatus = async () => {
    const online = await checkOnlineStatus();
    setOnlineStatus(online);
  };

  useEffect(() => {
    window.addEventListener("offline", () => {
      setOnlineStatus(false);
    });

    const id = setInterval(() => {
      checkStatus();
    }, onlinePollingInterval);

    return () => {
      window.removeEventListener("offline", () => {
        setOnlineStatus(false);
      });

      clearInterval(id);
    };
  }, []);

  return (
    <DetectOfflineContext.Provider value={onlineStatus}>
      {children}
    </DetectOfflineContext.Provider>
  );
}
